/**
 * Anonymous, aggregate usage beacon (issue #16) — subject is a template id,
 * symbol id, or trimmed search term, never design content (text, colours,
 * photos). This is a real behavioural change from the README's "nothing you
 * type is ever sent to a server" claim, which is why it's this narrow: a
 * fixed event name plus one short, non-personal identifier, nothing else.
 */
export type MetricEvent = 'view' | 'download_stl' | 'download_stl_zip' | 'download_3mf' | 'search' | 'symbol_pick' | 'highlight_click'

/** Fire-and-forget: never awaited by callers, never throws, and must never block or fail the action it's reporting on. */
export function sendMetric(event: MetricEvent, subject?: string) {
  fetch('/api/v1/metrics', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event, subject }),
    keepalive: true,
  }).catch(() => {})
}

export type TemplateStats = {
  templateId: string
  views: number
  downloadStl: number
  downloadStlZip: number
  download3mf: number
  downloadRenderZip: number
  shareHits: number
  highlightClicks: number
}
export type SubjectCount = { subject: string; count: number }
export type MetricsSummary = {
  totals: Record<string, number>
  byTemplate: TemplateStats[]
  topSearches: SubjectCount[]
  topSymbols: SubjectCount[]
}

/** Admin-only aggregate stats for the #/stats page. Null if signed out, not admin, or offline. */
export async function getMetricsSummary(): Promise<MetricsSummary | null> {
  try {
    const r = await fetch('/api/v1/metrics/summary')
    if (!r.ok) return null
    return r.json()
  } catch {
    return null
  }
}
